import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { useToastProvider } from './useToastProvider'
import ToastComponent from './ToastComponent.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

const toastProvider = useToastProvider()
const toasts = toastProvider.toasts

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast, index) => {
      return (_openBlock(), _createBlock(ToastComponent, {
        key: index,
        toast: toast
      }, null, 8, ["toast"]))
    }), 128))
  ]))
}
}

})